/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateWatchlistDto
 */
export interface UpdateWatchlistDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateWatchlistDto
     */
    iconName: UpdateWatchlistDtoIconNameEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateWatchlistDto
     */
    colorName: UpdateWatchlistDtoColorNameEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateWatchlistDto
     */
    name: string;
}

/**
* @export
* @enum {string}
*/
export enum UpdateWatchlistDtoIconNameEnum {
    Wallet = 'Wallet',
    WalletFilled = 'WalletFilled',
    Profits = 'Profits',
    ProfitsFilled = 'ProfitsFilled',
    Trades = 'Trades',
    TradesFilled = 'TradesFilled',
    Dividends = 'Dividends',
    DividendsFilled = 'DividendsFilled',
    AccountingDocument = 'AccountingDocument',
    Bell = 'Bell',
    BellFilled = 'BellFilled',
    ChartBar = 'ChartBar',
    HeartFilled = 'HeartFilled',
    Heart = 'Heart',
    CompoundInterest = 'CompoundInterest',
    ChartBarFilled = 'ChartBarFilled'
}/**
* @export
* @enum {string}
*/
export enum UpdateWatchlistDtoColorNameEnum {
    Blue = 'blue',
    BlueLight = 'blueLight',
    BlueDark = 'blueDark',
    Purple = 'purple',
    PurpleLight = 'purpleLight',
    PurpleDark = 'purpleDark',
    Green = 'green',
    GreenLight = 'greenLight',
    GreenDark = 'greenDark',
    Primary = 'primary',
    PrimaryLight = 'primaryLight',
    PrimaryDark = 'primaryDark',
    Secondary = 'secondary',
    SecondaryLight = 'secondaryLight',
    SecondaryDark = 'secondaryDark',
    Gray = 'gray',
    GrayLight = 'grayLight',
    GrayDark = 'grayDark',
    Orange = 'orange',
    OrangeLight = 'orangeLight',
    OrangeDark = 'orangeDark',
    Red = 'red',
    RedLight = 'redLight',
    RedDark = 'redDark',
    Pink = 'pink',
    PinkLight = 'pinkLight',
    PinkDark = 'pinkDark',
    Brown = 'brown',
    BrownLight = 'brownLight',
    BrownDark = 'brownDark',
    Yellow = 'yellow',
    YellowLight = 'yellowLight',
    YellowDark = 'yellowDark'
}

export function UpdateWatchlistDtoFromJSON(json: any): UpdateWatchlistDto {
    return UpdateWatchlistDtoFromJSONTyped(json, false);
}

export function UpdateWatchlistDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateWatchlistDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'iconName': json['iconName'],
        'colorName': json['colorName'],
        'name': json['name'],
    };
}

export function UpdateWatchlistDtoToJSON(value?: UpdateWatchlistDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'iconName': value.iconName,
        'colorName': value.colorName,
        'name': value.name,
    };
}

